import dayjs from "dayjs";

interface DateTimeFormatterProps {
    timestamp?: string | number;
    dateTimeformat?: string;
    dateFormat?: string;
    timeFormat?: string;
    type?: "dateTime" | "date" | "time";
}

/**
 * DateTimeFormatter
 * is used for displaying timestamp to user readable format (connected to store for user defined formats from API)
 * Default Props Examples:
 *   dateTimeformat: 'MM/DD/YYYY hh:mm A',
 *   timeFormat: 'hh:mm A',
 *   dateFormat: 'MM/DD/YYYY',
 */
export const DateTimeFormatter = ({
    timestamp,
    dateTimeformat,
    dateFormat,
    timeFormat,
    type = "dateTime",
}: DateTimeFormatterProps) => {
    let format = dateTimeformat ?? "MMMM D, YYYY hh:mm A";
    if (type === "date") format = dateFormat ?? "MM/DD/YYYY";
    else if (type === "time") format = timeFormat ?? "hh:mm A";

    return timestamp ? <>{dayjs(timestamp).format(format)}</> : null;
};
